export function getInitialStateCreditos() {
   const fechaPrimerVencimientoDefault = new Date();
   fechaPrimerVencimientoDefault.setDate(
      fechaPrimerVencimientoDefault.getDate() + 30,
   );

   return {
      scoreForm: {
         dniCuit: '',
         nombreRazonSocial: '',
         dniCuitCodeudor: '',
         nombreRazonSocialCodeudor: '',
         ingresoNetoFacturacion: null,
         montoRequerido: null,
         atendidoPor: null,
      },
      simuladorForm: {
         linea: null,
         valorVehiculo: null,
         anioVehiculo: null,
         montoAFinanciar: null,
         capital: null,
         plazo: null,
         fechaPrimerVencimiento: fechaPrimerVencimientoDefault,
         atendidoPor: null,
      },
      simulacionResultado: null,
      loadingScore: false,
      scoreEnviado: false,
   };
}

export default getInitialStateCreditos();
